export default __webpack_public_path__ + "static/media/22-SoundTrack Your Brand-White.7cffa7e2.png";